const kitStatusLabels = Object.freeze({
  ASSIGNED: 'Kit Available',
  PROCESSING: 'Processing',
  UNASSIGNED: 'Unassigned',
  REQUESTED: 'Order Received by Microba',
  ALLOCATED: 'Allocated',
  DISPATCHED_BY_MICROBA: 'Dispatched by Microba',
  RECEIVED_BY_CUSTOMER: 'Recieved by Customer',
  RECEIVED_BY_MICROBA: 'Received by Microba',
  RESULTS_AVAILABLE: 'Results Available',
  MICROBIOME_COACH_SESSION_COMPLETED: 'Microbiome Coach Session Completed',
  REPLACED: 'Replaced',
  FAILED_OVERLOADED: 'Failed Overloaded',
  FAILED_UNDERLOADED: 'Failed Underloaded',
  FAILED_SWAB_OTHER: 'Failed Swab Other',
  FAILED_PROCESSING: 'Failed Processing',
  REDEEMED: 'Redeemed',
  INVALIDATED: 'Invalidated',
  REFUNDED: 'Refunded'
})

const kitStatuses = Object.freeze({
  ASSIGNED: 'ASSIGNED',
  PROCESSING: 'PROCESSING',
  UNASSIGNED: 'UNASSIGNED',
  REQUESTED: 'REQUESTED',
  ALLOCATED: 'ALLOCATED',
  DISPATCHED_BY_MICROBA: 'DISPATCHED_BY_MICROBA',
  RECEIVED_BY_CUSTOMER: 'RECEIVED_BY_CUSTOMER',
  RECEIVED_BY_MICROBA: 'RECEIVED_BY_MICROBA',
  RESULTS_AVAILABLE: 'RESULTS_AVAILABLE',
  MICROBIOME_COACH_SESSION_COMPLETED: 'MICROBIOME_COACH_SESSION_COMPLETED',
  REPLACED: 'REPLACED',
  FAILED_OVERLOADED: 'FAILED_OVERLOADED',
  FAILED_UNDERLOADED: 'FAILED_UNDERLOADED',
  FAILED_SWAB_OTHER: 'FAILED_SWAB_OTHER',
  FAILED_PROCESSING: 'FAILED_PROCESSING',
  REDEEMED: 'REDEEMED',
  INVALIDATED: 'INVALIDATED',
  REFUNDED: 'REFUNDED'
})

export { kitStatusLabels, kitStatuses }
